const POSTS_KEY = {
  ALL: 'all',
  ARTICLES: 'articles',
  CURRENT: 'current',
  DATA: 'data',
  WORKOUTS_LOGGED: 'workoutsLogged',
  PLANS_LOGGED: 'plansLogged'
}

export default POSTS_KEY
